module.exports = __webpack_public_path__ + "google_pixel-black@2x.png?a862f9f33b52e0f9c03af92028d38843";